import { render, staticRenderFns } from "./texts_list.vue?vue&type=template&id=84c3bd0a&scoped=true&"
import script from "./texts_list.vue?vue&type=script&lang=js&"
export * from "./texts_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c3bd0a",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Ftexts%2Ftexts_list.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/table.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Ftexts%2Ftexts_list.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "@/lang/search.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Ftexts%2Ftexts_list.vue"
if (typeof block2 === 'function') block2(component)

export default component.exports